import { StorableSession, StorableSessionInfo } from "./StorableSession.js";

export class SessionObject {


    constructor(
        public readonly session?: StorableSession,
        public readonly sessionInfo?: StorableSessionInfo,
        public readonly change_already_handled:boolean = false
    ) {

    }
        
}



